import type { MiddlewareAPI } from 'redux';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/operator/takeUntil';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import type { ActionsObservable } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import getDashboards from '../../services/dashboards/get/index.tsx';
import { RETRIEVE, retrieved, retrieveFailed } from '../../state/actions/dashboards/index.tsx';
import { getFilter } from '../../state/selectors/query/index.tsx';
import type { State, Action } from '../../state/types.tsx';
import { getServiceRequest } from './selectors.tsx';

const retrieveDashboards = (action$: ActionsObservable<Action>, store: MiddlewareAPI<State>) => {
	const getDashboardsRequestAction$ = action$.ofType(RETRIEVE);

	return getDashboardsRequestAction$.mergeMap(() => {
		const state = store.getState();
		const request = getServiceRequest(state);
		const filter = getFilter(state);
		const actionStartTimestamp = Date.now();

		return Observable.fromPromise(getDashboards(request, filter))
			.mergeMap((result) => Observable.of(retrieved(result)))
			.takeUntil(getDashboardsRequestAction$)
			.catch((error) => {
				fireErrorAnalytics({
					error,
					meta: {
						id: 'retrieveDashboards',
						packageName: 'jiraDashboardsMain',
						teamName: 'keystone',
					},
					attributes: {
						durationInMs: Date.now() - actionStartTimestamp,
					},
				});
				return Observable.of(retrieveFailed());
			});
	});
};

export default retrieveDashboards;
